import { FlowyProject } from "../components/gizmos";
import usePlatformCB from "./usePlatformCB";
import { beneficiaryProject } from "./gizmoConfigurations";
import * as S from "./BaseProject.styles";

/**
 *  We created this in order to not touch the DefaultProject component.
 */
const BaseProject: React.FC = () => {
  const { platformOperationCB, params } = usePlatformCB();

  return (
    <S.BaseProject>
      <FlowyProject
        config={beneficiaryProject}
        platformCallbacks={{
          platformOperationCB,
        }}
        params={params}
      />
    </S.BaseProject>
  );
};

export default BaseProject;
